import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { fetchItems, addItem } from "./ItemApi";


export function useItems() {
    return useQuery(
        {
            queryKey: ['items'],
            queryFn: fetchItems
        }
    )
}



export function useEditItem() {
    const queryClient = useQueryClient();
    return useMutation(
        {
            mutationFn: addItem,
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ['items']
                })
            }
        }
    );
}

